<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly />
            </div>
          </FormSection>
          <FormSection title="Donation Amount">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow>
              <input
                type="checkbox"
                @click="setValue('custom.hideNameShow', $event.target.checked)"
                id="hideNameShow"
                style="margin-right: 5px; margin-top: -3px"
              />
              <FormLabel for="hideNameShow" style="font-weight: normal"
                >Don't show my name in Donor list</FormLabel
              ><br /><br />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
            <FormRow>
              <NewsletterSubscribe
                text="Sign me up for the OU's weekly Shabbat Shalom email"
                class="signup"
              />
            </FormRow>
            <br />
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    return {
      form,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .ou-donation-form hr {
  margin-top: 0px;
}

label.signup {
  font-weight: normal;
}
</style>
